import React from 'react';
import cx from 'classnames';
import { TabListTreeNodeData } from '@mutiny-pkg/champaign-schemas/src/schemas/flexiblePages/flexiblePagesTreeNode';
import { transformToContainerQueries } from '../utils/transformBreakpointClasses';

// TypeScript declarations for Tailwind Plus Elements
/* eslint-disable @typescript-eslint/no-namespace */
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'el-tab-list': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
        class?: string;
        key?: string;
      };
    }
  }
}
/* eslint-enable @typescript-eslint/no-namespace */

type TabListProps = {
  id: string;
  editorClassName?: string;
  children: React.ReactNode;
  isEditor?: boolean;
} & TabListTreeNodeData;

export const TabList = React.forwardRef<HTMLElement, TabListProps>(
  ({ id, className, editorClassName, children, isEditor = false, ...props }, ref) => {
    return (
      <el-tab-list
        ref={ref}
        id={id}
        class={cx(transformToContainerQueries(className, { isEditor }), editorClassName)}
        {...props}
      >
        {children}
      </el-tab-list>
    );
  },
);

TabList.displayName = 'TabList';
